import { Component, OnInit,Inject,Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { DataService } from '../../services/data.service';
import { Impactos,GrupoAplicativo,Aplicativos,IniciativaDetalle } from 'src/app/interfaces/interfaces';
import { ModalCosteoConsultaComponent } from 'src/app/components/modal-costeo-consulta/modal-costeo-consulta.component';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { NotifierService } from 'angular-notifier';



@Component({
  selector: 'app-modal-consulta-iniciativa',
  templateUrl: './modal-consulta-iniciativa.component.html',
  styleUrls: ['./modal-consulta-iniciativa.component.css']
})
export class ModalConsultaIniciativaComponent implements OnInit {
  infoiniciativa;
  idIniciativa:string;
  iniciativa: IniciativaDetalle;
 arrayImpactosConsulta: Impactos[]=[];
 mostrardescargarArchivoPA:boolean=false;
  mostrardescargarArchivoPP:boolean=false;
  mostrardescargarArchivoAN:boolean=false;
  nombreArchivoPP:string;
  nombreArchivoPA:string;
  nombreArchivoAN:string;
  idProceso:number;
  gruposAplicativos: GrupoAplicativo[];
  tiposAplicativos: Aplicativos[];
  idRolSeleccionado:number;
  //Combos
  id_aplicacion:number;
  id_area:number;

  editarAplicacion:boolean=false;
  userlogin:string;
  loading:boolean=false;

  listaEquipo:any[]=[];
  listaEquipoData:any[]=[];
  desarrollador:any[]=[];
  nombreAnalista:string;
  nombreLider:string;
  nombreEnlace:string;
  emailUser:string;

  

  constructor(private dataService: DataService, 
    private authService: AuthService,
    public dialog:MatDialog, private router: Router,
    private notifier: NotifierService) 
  {}

  ngOnInit(): void {
    this.authService.escuchaRolSeleccionado().subscribe((res) => {
      this.idRolSeleccionado = res;
    });
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
    });
    this.idIniciativa = localStorage.getItem("editarIniciativaId");
    this.verDetallesIniciativa(parseInt(this.idIniciativa));
    this.getEquipoTrabajo(parseInt(this.idIniciativa));
  }


  //Método para cargar la lista de miembros de equipo
  getEquipoTrabajo(id_iniciativa:number)
  {
    this.dataService.getEquipoTrabajo(id_iniciativa).subscribe(data => {
      this.listaEquipoData=data['data'];
      this.listaEquipoData.forEach(element => {
        if(element['estatus_equipoTrabajo']==true && element['confirmacion_equipoTrabajo']==true)
        {
          this.listaEquipo.push(element);

        }
        
      }); 


    });

  }
  
  verDetallesIniciativa(id: number) 
  {
    this.dataService.detalleIniciativa(id).subscribe(data => {
      if (data['objData']) 
      {
        //this.iniciativaSeleccionada = data['objData'];        
        this.idProceso=data['objData']['id_proceso'];
        this.iniciativa= data['objData'];
        this.userlogin=this.emailUser;
        //this.userlogin=data['objData']['email_usuarioRegistro'];
        if(this.iniciativa.id_tipoIniciativa==3 || this.iniciativa.id_tipoIniciativa==2)
        {
          this.iniciativa.nombreAplicacion=this.iniciativa.nombre_aplicacion;
          this.iniciativa.nombreArea=this.iniciativa.nombre_area;

          //Obtenemos los grupos de sistemas
          this.dataService.obtenerGruposSistemas().subscribe(data => {
            this.gruposAplicativos = data['data'];

             /*Obtenemos el area dueña de la aplicacion*/
             for(let v of this.gruposAplicativos)
             {
               if(v.id_area==this.iniciativa.id_area){
                 this.iniciativa.nombreArea=v.nombre_area;
               }
             }
          });

         
            /*Obtenemos el aplicativo */
            this.aplicativosAreas(this.iniciativa.id_area);
        }
        //this.iniciativaSeleccionada = data['objData'];
        if(this.iniciativa.doc_procesoActual)
        {
          this.mostrardescargarArchivoPA=true;
          this.nombreArchivoPA=this.iniciativa.doc_procesoActual;
        }
        if(this.iniciativa.doc_procesoPropuesto)
        {
          this.mostrardescargarArchivoPP=true;
          this.nombreArchivoPP=this.iniciativa.doc_procesoPropuesto;
        }
        if(this.iniciativa.docAnexos_iniciativas)
        {
          this.mostrardescargarArchivoAN=true;
          this.nombreArchivoAN=this.iniciativa.docAnexos_iniciativas;
        }
        const tempImpactos=data['objData'].jsonIniciativaImpacto;
        //this.iniciativaSeleccionada.impactos = [];
        if (tempImpactos) 
        {
          tempImpactos.split('|').forEach((element) => {
            let j:Impactos[]=JSON.parse(element)
            this.iniciativa.arrayImpactosConsulta=j;
          });
        }
       
      }
    });
  }

  updateAplicacion()
  {
    
    this.editarAplicacion=true;
    this.id_area=this.iniciativa['id_area'];
    this.id_aplicacion=this.iniciativa['id_aplicacion'];
    //Cargamos los aplicativos
    //this.aplicativosAreas(this.iniciativa.id_area);
  }

  guardarAplicacion()
  {
    this.loading=true;
    let valores={
      'id_iniciativa':this.iniciativa.id_iniciativa,
      'id_aplicacion':this.id_aplicacion,
      'id_area':this.id_area,
      'userlogin':this.userlogin,
      'rolUserlogin':this.idRolSeleccionado
    }
    this.dataService.UpdateAplicacionIniciativa(valores).subscribe(
      data => {
        if (data['objData']) 
        {
          this.loading=false;
          this.notifier.notify('success', 'Aplicación editada correctamente.');
          this.verDetallesIniciativa(this.iniciativa.id_iniciativa); 
          this.editarAplicacion=false;
        }
      },
      error => {
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar editar la aplicación. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );

  }//Cierre del metodo

  
  aplicativosAreas(idGrupo: number) 
  {
    this.dataService.obtenerAplicativos(idGrupo).subscribe(
      data => {
        if (data['data']) {
          this.tiposAplicativos = data['data'];
           /*Obtenemos el area dueña de la aplicacion*/
          for(let v of this.tiposAplicativos)
          {
            if(v.id_aplicacion==this.iniciativa.id_aplicacion){
              this.iniciativa.nombreAplicacion=v.nombre_aplicacion;
            }
          }
        }
      },
      error => {
      }
    );
  }

  onChangeGrupo(idArea: number)
  {
    this.id_aplicacion=0;
    this.dataService.obtenerAplicativos(idArea).subscribe(
      data => {
        if (data['data']) {
          this.tiposAplicativos = data['data'];
        }
      },
      error => {
        console.log(error);
      }
    );

  }

  descargarArchivo(archivo:string)
  {
    this.dataService.descargarArchivo(this.iniciativa.id_iniciativa,archivo).subscribe(res => {
      // Este es necesario para crear un objeto blob con el tipo de archivo
      // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
      let newBlob = new Blob([res], { type: this.obtenerTipoArchivo(archivo) });
      // IE no permite objetos blob directamente en el atributo href de un link
      // en su lugar hay que usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
       let link = document.createElement('a');
      link.href = data;
      link.download = archivo;
      // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);

    });

  }

  private obtenerTipoArchivo(archivo: string): string {
    let tipoArchivo: string;
    let extencion: string = archivo.split('.').pop();

    switch (extencion) {
      case 'pdf':
        tipoArchivo = 'application/pdf';
        break;
      case 'xls':
        tipoArchivo = 'application/vnd.ms-excel';
        break;
      case 'xlsx':
        tipoArchivo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case 'csv':
        tipoArchivo = 'application/csv';
        break;
      case 'zip':
        tipoArchivo = 'application/zip';
        break;
      case 'rar':
        tipoArchivo = 'application/x-rar-compressed';
        break;

      default:
        tipoArchivo = 'text/plain';
        break;
    }
    return tipoArchivo;
  }

    //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalCosteoConsulta()
 { 
   const dialogRef = this.dialog.open(ModalCosteoConsultaComponent,{data:{id_iniciativa:this.idIniciativa,id_proceso:this.iniciativa.id_proceso},disableClose:false});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
       
     }
     else{
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

getBackgroundColor(idEstatus: number): string {
  const colors: { [key: number]: string } = {
    4: 'rgb(230, 136, 138)',
    5: 'rgb(140, 200, 189)',
    6: 'transparent', // Sin color de fondo
    7: 'rgb(197, 201, 72)',
    8: 'rgb(255, 192, 0)',
    9: 'rgb(0, 0, 255)',
    10: 'rgb(0, 176, 80)',
    11: 'rgb(255, 0, 0)',
    12: 'rgb(89, 89, 89)',
    13: 'rgb(0, 0, 0)',
    15: 'rgb(133, 122, 160)',
    16: 'rgb(174, 12, 96)', // Color para el estado 16
  };
  return colors[idEstatus] || 'transparent'; // Default
}

getTextColor(idEstatus: number): string {
  const textColors: { [key: number]: string } = {
    6: 'black', // Ejemplo donde el texto no es blanco
    9: 'white',
    11: 'white',
    12: 'white',
    13: 'white',
    15: 'white',
    16: 'white', // Color para el estado 16
  };
  return textColors[idEstatus] || 'black'; // Default
}


cancelar()
{     
  if(this.idRolSeleccionado==9 || this.idRolSeleccionado==10 ||this.idRolSeleccionado==11
    ||this.idRolSeleccionado==3 ||this.idRolSeleccionado==4 ||this.idRolSeleccionado==5 
    ||this.idRolSeleccionado==12 ||this.idRolSeleccionado==6 ||this.idRolSeleccionado==7 ||this.idRolSeleccionado==8 )
  {
    this.router.navigate(['./iniciativas'])
  }
  else{
    this.router.navigate(['./mis-iniciativas'])
  }
}
/***********************************************************************************************************************************/
/**Validación para los estados dentro del modal de consulta 
 * ialvaradop 11/12/2024 10:40 p.m.
*/
getEstatusBadge(): string { 
  // Validar el id_rol
  if (this.idRolSeleccionado==1 || this.idRolSeleccionado==2) {
    // Si el id_rol es 1 o 2
    if (this.iniciativa?.id_estatusIniciativa_anterior) {
      return this.iniciativa.nombre_estatus_anterior || '';
    }
  } else {
    // Si el id_rol no es 1 ni 2
    if (this.iniciativa?.id_estatusIniciativa) {
      return this.iniciativa.nombre_estatusIniciativa || '';
    }
  }
  return '';
}
}//cierre de clase
